import Footer from '../../footer/Footer';
import Navbar from '../../navbar/Navbar';
import AboutLeftTab from '../../About/AboutLeftTab';

function HemasriGoldMedalFelicitation() {
    return (
        <div>
            <Navbar />

            <div className="graduate-admission pt-lg-5 pt-4 pb-70">
                <div className="container">
                    <div className="row">
                        <AboutLeftTab />

                        <div className="col-lg-8 ps-lg-4 order-1 order-lg-2">
                            <div className="col-lg-12 ps-lg-4">
                                <div className="how-to-apply">

                                    <h2 className="pb-2">
                                        Felicitation of P. Hemasri (B.Tech IT) – JNTUH Gold Medalist
                                    </h2>

                                    <p>
                                        Ms. <strong>P. HemaSri</strong>, a double gold medalist from JNTUH, along with her
                                        parents, was felicitated at a ceremony held yesterday for her outstanding
                                        achievement in <strong>B.Tech IT</strong>. The Management presented her with a
                                        cash award of <strong>Rs. 50,000</strong> in recognition of her exceptional
                                        performance.
                                        <br /><br />
                                        The felicitation ceremony, held at the college premises, was graced by esteemed
                                        dignitaries, including <strong>Dr. K. Radhakishan Rao</strong> (Vice Chairman),
                                        <strong> Dr. T. Ravinder Reddy</strong> (Advisor), <strong>Dr. A. Narmada</strong> (Principal),
                                        and <strong>Dr. B. Narendra Kumar</strong> (Dean IIC & Outreach).
                                        <br /><br />
                                        HemaSri has been awarded two prestigious gold medals from JNTUH:
                                        <br />
                                        1. <strong>Best Outgoing Student of B.Tech Information Technology</strong> across all
                                        JNTUH-affiliated colleges.
                                        <br />
                                        2. <strong>Sangam Laxmibai Memorial Gold Medal</strong> for being the best outgoing
                                        girl student of B.Tech (Information Technology) in JNTUH-affiliated colleges.
                                        <br /><br />
                                        Notably, this achievement marks the <strong>8th Gold Medal for SWEC since 2012</strong>,
                                        a testament to the institution’s continuous commitment to academic excellence as
                                        it enters its <strong>Silver Jubilee year</strong>.
                                    </p>

                                    <div className="spotlight-group">
                                        <div className="row">
                                            <div className="col-md-6 mb-3 mb-lg-4">
                                                <a
                                                    className="spotlight"
                                                    href="https://admin.swec.ac.in/assetsswec/img/hemasri-92387803.jpg"
                                                >
                                                    <img
                                                        src="https://admin.swec.ac.in/assetsswec/img/hemasri-92387803.jpg"
                                                        loading="lazy"
                                                        alt="Felicitation of P. Hemasri – JNTUH Gold Medalist"
                                                        className="img-responsive center-block rounded-1"
                                                    />
                                                </a>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>

            <Footer />
        </div>
    );
}

export default HemasriGoldMedalFelicitation;
